import Breadcrumb from '~/src/common/components/Breadcrumb';
import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n';
import { useGoBack } from '~/src/common/services/Router';
import { CommonCatalogEventProperties } from '~/src/common/services/Tracker';
import {
  GetDetailBySlug200,
  GetRecipeByIdOrSlug200,
} from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  item: Nullable<GetDetailBySlug200 | GetRecipeByIdOrSlug200>;
  className?: string;
  analyticsProperties: CommonCatalogEventProperties;
}

export const CatalogContentBreadcrumb = (props: Props) => {
  const { handleBack } = useGoBack(props.analyticsProperties);

  return (
    <S.NavigationContainer className={props.className}>
      <S.GoBackButton onClick={handleBack}>
        <Icon name="Arrow-back" size={16} />
        <span>{I18n.t('common.back')}</span>
      </S.GoBackButton>
      <S.BreadcrumbsContainer>
        <Breadcrumb item={props.item} />
      </S.BreadcrumbsContainer>
    </S.NavigationContainer>
  );
};
